// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

// MUI imports
import { createTheme, ThemeProvider } from '@mui/material/styles';

// 1) Define a custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#005f3b', // A dark green
    },
    secondary: {
      main: '#81c784', // A lighter green
    },
    background: {
      default: '#f8f9fa', // optional: tweak overall background
    },
  },
  typography: {
    // 2) Tweak font sizes, headings, etc.
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      letterSpacing: '0.5px',
    },
    body1: {
      lineHeight: 1.6,
    },
  },
  components: {
    // 3) Optional component overrides
    MuiDrawer: {
      styleOverrides: {
        paper: {
          // Slightly darker background for the drawer
          backgroundColor: '#eef2f1',
          borderLeft: '1px solid #ccc',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          margin: '4px 0',
          '&:hover': {
            backgroundColor: '#cce7db', // a faint green hover
          },
          '&.Mui-disabled': {
            opacity: 0.5,
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
